const Fechas = {
    columns: [
        { title: 'Fecha', field: 'fecha', type:'date',
        },
        { title: 'Link de Google Meet', field: 'Link', type:'string',
        },
      ],
      data: [
        { fecha: '2020-07-10T21:11:54'},
        { fecha: '2020-07-21T21:11:54'},
        { fecha: '2020-07-23T21:11:54'},
        { fecha: '2020-07-24T21:11:54'},
      ],
        
    };

export default Fechas;